import React from 'react';
import {Button, Icon, Modal, Radio, Table} from 'antd';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {createComplaintByAssetService, fetchSubDocumentFilter, fetchSubElementFilter} from '../../appRedux/actions';
import ComplaintCreate from "../../containers/Complaint/create";

class ComplaintModal extends React.Component {

  id = 0;

  state = {
    visible: false,
    formVisible: false,
    modalOpen: 1,
    edit: false,
    complaintDataList: {},
  };

  componentDidMount() {
    this.props.fetchSubElementFilter('Complaint');
    const { data = {} } = this.props;
    this.setState({
      complaintDataList: data
    })
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps && this.props && JSON.stringify(nextProps) !== JSON.stringify(this.props)) {
      this.setState({ complaintDataList: nextProps.data });
    }
  }

  remove = (id) => {
    this.setState({
      complaintDataList: null,
      modalOpen: 1,
    }, ()=> {
      this.props.getComplaintData(null);
    });
  };

  showModal = () => {
    this.setState({
      visible: true,
    });
  };
  showFormModal = () => {
    this.setState({
      formVisible: true,
    });
  };

  handleCancel = () => {
    this.setState({
      visible: false,
    });
  };

  handleCancelComplaint = () => {
    this.setState({
      formVisible: false,
    });
  };

  handleChange = () => {
  };

  handleChangeComplaint = () => {
  };

  handleCreate = () => {
    this.showFormModal();
    this.handleCancel();
  };

  edit = (id) => {
    this.props.history.push(`/complaint/edit/${id}`);
  };

  handleSubmitComplaint = (values, assetServiceId, e) => {
    e.stopPropagation();
    this.props.createComplaintByAssetService(values, assetServiceId, this.props.index);
    this.handleCancelComplaint();
    let { complaintDataList } = this.state;
    complaintDataList = this.props.complaintData;
    this.setState({ complaintDataList: complaintDataList, modalOpen: 0 });
    this.props.getComplaintData(this.props.complaintData);
    this.handleCancel();
  };

  handleSelect = (id) => {
    const { complaints } = this.props;
    let { complaintDataList } = this.state;
    const complaintData = complaints && complaints.filter((item) => item._id === id);
    complaintDataList = complaintData[0];
    this.setState({ complaintDataList: complaintDataList, modalOpen: 0 });
    this.props.getComplaintData(complaintData[0]);
    this.handleCancel();
  };

  complaintTable() {
    const { data, title, history, complaints, showComplaints } = this.props;
    const complaintDataSource = [];
    const complaintColumns = [
      {
        title: 'Complaint Code',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: 'Link Existing',
        dataIndex: 'linkExisting',
        key: 'linkExisting',
        render: (item) => <Radio value={item._id} onClick={this.handleSelect.bind(this, item._id)}></Radio>
      }
    ];
    // let complaintTableData = complaints && complaints.filter(item1 =>
    //   !showComplaints.some(item2 => item2.complaint && (item2.complaint._id === item1._id)));
    let complaintTableData = complaints || [];

    complaintTableData && complaintTableData.map(item => {
      complaintDataSource.push({
        key: item._id || Math.random(),
        name: item.complaintNo,
        linkExisting: item
      })
    });
    return <Table columns={complaintColumns} dataSource={complaintDataSource} pagination={false}/>
  }

  formItems() {
    const {isDisabled} = this.props;
    const { complaintDataList } = this.state;
    const style = {
      // border: '1px dashed #000',
      // borderRadius: '5px',
      marginTop: '5px',
      marginBottom: '0px',
      padding: '5px',
      display: 'flex',
      justifyContent: 'space-between'
    };
    if (complaintDataList) {
        return <div key={complaintDataList._id} style={style}>
          <div>
            <div>Complaint No. - {complaintDataList.complaintNo}</div>
            <div>Created By - {complaintDataList.createdBy && complaintDataList.createdBy.name}</div>
            <div>Details Of Complaint - {complaintDataList.detailsOfComplaint}</div>
          </div>
          <div>
            {complaintDataList._id ? <Button type='primary' disabled={isDisabled} onClick={() => {this.edit(complaintDataList._id)}}>Edit</Button> : ''}
            <Button
              type='danger'
              disabled={isDisabled}
              onClick={this.remove.bind(this, complaintDataList._id)}
            >Remove</Button>
          </div>
        </div>
    }
  }

  render() {
    const { modules, complaints, form, subComplaintFilters } = this.props;
    const { modalOpen, visible, formVisible } = this.state;
    const subFilters = Object.assign({}, subComplaintFilters);
    delete subFilters.asset;
    delete subFilters.complaintType;

    const style = {
      marginTop: '10px',
      border: '1px dashed #000',
      padding: '20px',
      borderRadius: '9px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    };

    return (
      <div>
        <Modal
          visible={visible}
          onCancel={this.handleCancel}
          destroyOnClose={true}
          footer={null}
          width={640}
        >
          <div style={{display: 'flex', flexDirection: 'column', paddingTop: '20px'}}>
            <div>
              <Button onClick={this.handleCreate} style={{width: '60%', marginTop: '15px'}}>
                <Icon type="plus"/> Create New Complaint
              </Button>
            </div>
            {this.complaintTable()}
          </div>
        </Modal>


        <Modal
          title="Create Complaint"
          visible={formVisible}
          onCancel={this.handleCancelComplaint}
          footer={null}
          width={720}
        >
          <ComplaintCreate
            filters={subFilters}
            modules={''}
            title={'CREATE'}
            resource={'Complaint'}
            onChange={this.handleChangeComplaint.bind(this)}
            onSubmit={this.handleSubmitComplaint.bind(this)}
            loading={false}
            history={this.props.history}
            match={this.props.match}
          />
        </Modal>
        <br/>
        {this.formItems()}
        {
          !this.state.complaintDataList && <Button type="dashed" onClick={this.showModal} style={{ width: '100%', marginBottom: '5px', marginTop: '2px' }}>
            <Icon type="plus"/> Create Complaint
          </Button>
        }

      </div>

    );
  }
}

const mapStateToProps = ({ commonData, assetService }) => {
  return {
    filters: commonData.filters,
    modules: commonData.modules,
    subDocumentFilters: commonData.subDocumentFilters,
    subComplaintFilters: commonData.subElementFilters,
    complaintData: assetService.complaintData,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    fetchSubDocumentFilter,
    fetchSubElementFilter,
    createComplaintByAssetService,
  };
}

export default connect(mapStateToProps, mapDispatchToProps())(ComplaintModal);
ComplaintModal.defaultProps = {};

ComplaintModal.propTypes = {
  item: PropTypes.object,
};
